import { ClaimTypesEnum } from './../../../../../../../enums/claim-types.enum';
import { Component, inject, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { Subject } from 'rxjs';
import { TranslocoModule } from '@ngneat/transloco';
import { CommonModule } from '@angular/common';
import { LayoutService } from '../layout-service/layout.service';
import { Claim, ConfigService } from '../../../../../../../synlab-access-ui-components/core';
import { take } from 'rxjs/operators';
import { MPI_ID_QUERY_PARAM_NAME } from '../../../constants';

@Component({
  selector: 'app-right-sidebar',
  standalone: true,
  imports: [RouterLink, TranslocoModule, CommonModule],
  templateUrl: './right-sidebar.component.html',
  styleUrl: './right-sidebar.component.scss'
})
export class RightSidebarComponent implements OnInit, OnDestroy, OnChanges {

  private readonly router = inject(Router);

  public readonly layoutService = inject(LayoutService);

  private readonly configService = inject(ConfigService);

  public readonly showRightSidebar = this.layoutService.showRightSidebar;

  @Input()
  public wards: any[] = [];

  @Output()
  public logOut = new Subject<void>();

  @Input()
  public currentUserClaims: Claim[] = [];

  public userEmail: string = '';

  public userHasNoEmail: boolean = false;

  public givenName: string = '';

  public familyName: string = '';

  public userPhone: string = '';

  public baseProfileUrl: string = '';

  private readonly onDestroy$ = new Subject<void>();

  @Input()
  public selectedMpiId: string = '';

  public currentUserMpiId: string = '';

  ngOnInit(): void {
    this.setupConfig();
    this.subscribeToUserInfo();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.subscribeToUserInfo();
  }

  private setupConfig() {
    this.configService.config$.pipe(take(1)).subscribe(config => this.baseProfileUrl = config.baseProfileUrl);
  }

  public wardSwitch(mpiId: string) {
    this.showRightSidebar.set(false);
    this.router.navigate(['/results/category'], {
      queryParams: {
        [MPI_ID_QUERY_PARAM_NAME]: mpiId
      }
    });
  }

  private getClaimValue(claimType: ClaimTypesEnum) {
    return (this.currentUserClaims || []).find(claim => claim.claimType === claimType)?.claimValue || '';
  }

  private subscribeToUserInfo() {
    this.givenName = this.getClaimValue(ClaimTypesEnum.GIVEN_NAME);
    this.familyName = this.getClaimValue(ClaimTypesEnum.FAMILY_NAME);
    this.userEmail = this.getClaimValue(ClaimTypesEnum.EMAIL);
    this.userHasNoEmail = this.getClaimValue(ClaimTypesEnum.NO_EMAIL).toLowerCase() === 'true';
    this.userPhone = this.getClaimValue(ClaimTypesEnum.PHONE);
    this.currentUserMpiId = this.getClaimValue(ClaimTypesEnum.MPI_ID);
  }

  logout() {
    this.logOut.next();
  }

}
